export type PlatformName = "web" | "facebook" | "mobile";

export interface PlatformAdapter {
  name: PlatformName;
  load<T>(key: string, fallback: T): Promise<T>;
  save<T>(key: string, value: T): Promise<void>;
  share(text: string): Promise<boolean>;
  vibrate(pattern: number | number[]): void;
}

const STORAGE_PREFIX = "lexi-link:v2:";

export const webPlatform: PlatformAdapter = {
  name: "web",
  async load(key, fallback) {
    try {
      const item = localStorage.getItem(STORAGE_PREFIX + key);
      return item ? (JSON.parse(item) as typeof fallback) : fallback;
    } catch {
      return fallback;
    }
  },
  async save(key, value) {
    localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value));
  },
  async share(text) {
    const isNative = typeof window !== "undefined" && window.location.protocol === "capacitor:";
    if (isNative) {
      const { Share } = await import("@capacitor/share");
      await Share.share({
        title: "Lexi Link",
        text,
        dialogTitle: "Share your Lexi Link score"
      });
      return true;
    }

    if (navigator.share) {
      await navigator.share({ text });
      return true;
    }

    await navigator.clipboard.writeText(text);
    return true;
  },
  vibrate(pattern) {
    navigator.vibrate?.(pattern);
  }
};
